const value = {
    title: 'Данная функция недоступна',
    message:
      'Мы уже делаем все возможное, чтобы возобновить работу. Если у вас есть вопросы обратитесь в службу поддержки:',
  };

export default value;
